import {IUserGlobalServicesState} from '../state/user-global-services.state';
import {GlobalSettingsServicesAction, SETTINGS_GLOBAL_SERVICES_ACTION} from '../action/user-global-services.action';

const initialGlobalSettingsServicesState: IUserGlobalServicesState = {
  thisSite: {
    host: '',
    id: 0,
  },
  trial_applicable: {
    CUSTOM_BRANDING: false,
    MODIFY_MENU: false,
    REMEDIATION: false,
    USAGE_STATS: false,
    WHITE_LABEL: false,
  },
  user_services: {
    CUSTOM_BRANDING: {
      enabled: false,
      globalSettings: undefined,
      isTrial: false,
      sites: [],
    },
    MODIFY_MENU: {
      enabled: false,
      globalSettings: undefined,
      isTrial: false,
      sites: [],
    },
    REMEDIATION: {
      enabled: false,
      globalSettings: {},
      isTrial: false,
      sites: [],
    },
    USAGE_STATS: {
      enabled: false,
      globalSettings: {
        is_renewable: false,
        sitesStatsFor30days: undefined,
        sitesStatsFor60days: undefined,
        sitesStatsFor7days: undefined,
        sitesStatsFor90days: undefined,
      },
      isTrial: false,
      sites: [],
    },
    WHITE_LABEL: {
      enabled: false,
      globalSettings: undefined,
      isTrial: false,
      sites: [],
    },
    LIVE_TRANSLATIONS: {
      enabled: false,
      globalSettings: undefined,
      isTrial: false,
      sites: [],
    },
  },
};

export function settingGlobalServicesReducer(
  state: IUserGlobalServicesState = initialGlobalSettingsServicesState,
  action: GlobalSettingsServicesAction,
): IUserGlobalServicesState {
  switch (action.type) {
    case SETTINGS_GLOBAL_SERVICES_ACTION.INIT_GLOBAL_SETTINGS_SERVICES:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_GLOBAL_SERVICES_ACTION.RESET_GLOBAL_SETTINGS_SERVICES:
      return initialGlobalSettingsServicesState;
    default:
      return state;
  }
}
